import PropTypes from "prop-types";
import { useContext } from "react";
import { AccordionContext } from "./Accordion";

export function AccordionTrigger({ children, className, onClick, id }) {
  const { toggle } = useContext(AccordionContext);

  return (
    <span onClick={onClick || toggle} className={className}>
      {children}
    </span>
  );
}

AccordionTrigger.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  id: PropTypes.string,
};
